// TimeOff Type Enum
export enum TimeOffType {
  PTO = 'PTO',
  SICK = 'SICK',
  WFH = 'WFH',
}

// TimeOff Status Enum
export enum TimeOffStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

// TimeOff Category Enum
export enum TimeOffCategory {
  VACATION = 'Vacation/Personal Time',
  MEDICAL = 'Medical/Health',
  WFH = 'Work From Home',
  BUSINESS_TRAVEL = 'Business Travel',
  FAMILY_EVENT = 'Family Event',
  OTHER = 'Other',
}

// TimeOff Entry Interface
export interface TimeOffEntry {
  _id: string;
  employee: {
    _id: string;
    name: string;
    email: string;
    department?: {
      _id: string;
      name: string;
    };
  };
  startDate: string;
  endDate: string;
  type: TimeOffType;
  hours: number;
  status: TimeOffStatus;
  notes?: string;
  category?: TimeOffCategory;
  reason?: string;
  needsReview?: boolean;
  reviewReason?: string | null;
  vpEscalatedAt?: string | null;
  vpDecisionDueAt?: string | null;
  vpClaimedBy?: string | null;
  vpClaimedAt?: string | null;
  vpDecidedBy?: string | null;
  vpDecidedAt?: string | null;
  vpDeferredBy?: string | null;
  vpDeferredTo?: string | null;
  vpDeferredAt?: string | null;
  vpDecisionSource?: 'vp' | 'hr_override' | null;
  vpOverrideByUser?: string | null;
  leadsApproved?: boolean | null;
  originalCalendarSubject?: string;
  originalCalendarBody?: string;
  originalCalendarCategories?: string;
  originalCalendarShowAs?: string;
  originalCalendarIsAllDay?: boolean;
  originalCalendarLocation?: string;
  originalCalendarStart?: string;
  originalCalendarEnd?: string;
  originalCalendarTimeZone?: string;
  reconciled?: boolean;
  isFromCalendar?: boolean;
  isRecurring?: boolean;
  outlookEventId?: string;
  createdAt?: string;
  updatedAt?: string;
}

// TimeOff Form Data Interface
export interface TimeOffFormData {
  id?: string;
  employee: string;
  startDate: string;
  endDate: string;
  type: TimeOffType;
  hours: number;
  notes?: string;
  status?: TimeOffStatus;
  category?: TimeOffCategory;
  reason?: string;
  reconciled?: boolean;
}

// Recurring TimeOff Form Data Interface
export interface RecurringTimeOffFormData extends TimeOffFormData {
  pattern: 'weekly' | 'biweekly' | 'monthly';
  recurringEndDate: string;
}

// TimeOff Conflict Interface
export interface TimeOffConflict {
  employeeName: string;
  startDate: string;
  endDate: string;
  type: string;
}

// Response for time off email generation
export interface EmailContent {
  to: string;
  subject: string;
  content: string;
}

export interface EmailApiResponse {
  success: boolean;
  message: string;
  email: EmailContent;
} 